var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverResponseExportDefinitionType = void 0;
var ShapeDiverResponseExportDefinitionType;
(function (ShapeDiverResponseExportDefinitionType) {
  ShapeDiverResponseExportDefinitionType["UNKNOWN"] = "unknown";
  ShapeDiverResponseExportDefinitionType["DOWNLOAD"] = "download";
  ShapeDiverResponseExportDefinitionType["EMAIL"] = "email";
  ShapeDiverResponseExportDefinitionType["SHAPEWAYS"] = "shapeways";
})(ShapeDiverResponseExportDefinitionType || (exports.ShapeDiverResponseExportDefinitionType = ShapeDiverResponseExportDefinitionType = {}));
//# sourceMappingURL=SdResponseDtoExport.js.map
export default exports;